import { prettyName } from "common/helpers/Pretty";
import { RootState } from "common/reducers";
import { getTitle } from "common/selectors/org.selectors";
import { Nullable } from "common/types";
import { List, Record } from "immutable";

export const fromJSON = (json: Partial<ICrumbRecord>): CrumbRecord => {
  const record: ICrumbRecord = { ...(json as any) };
  return new CrumbRecord(record);
};

export const setupBreadCrumbs = (
  path: Nullable<string>,
  orgName: Nullable<string>,
  jobName: Nullable<string>,
  userOrgCount: number,
  state: RootState,
): List<CrumbRecord> => {
  const splittedPath = (List(path?.split("/") as string[]) || List())
    .filter((pathFilter) => pathFilter !== "")
    .slice(0, 3);
  let fullPath = "";
  const firstPathName = splittedPath.get(0);

  return splittedPath.map((pathName, idx) => {
    let name = prettyName[pathName] || pathName;
    fullPath += `/${pathName}`;
    if (firstPathName && idx === 2) {
      name = prettyName[`${firstPathName.slice(0, -1)}Sidebar_${pathName}`] || pathName;
    }

    let setPath = fullPath;
    if (pathName === "orgs") {
      if (userOrgCount > 0) {
        name = "Organizations";
      } else {
        setPath = `/${splittedPath.slice(0, 2).join("/")}/info`;
      }
    }
    if (!isNaN(pathName as any)) {
      if (splittedPath.includes("orgs")) {
        name = orgName || "Unset Org Name";
      } else if (splittedPath.includes("jobs")) {
        name = jobName || "Unset Job Name";
      }
    }

    if (pathName === "estimates") {
      name = getTitle(state, { documentType: "estimator", plural: true });
    } else if (pathName === "proposals") {
      name = getTitle(state, { documentType: "estimate", plural: true });
    } else if (pathName === "contracts") {
      name = getTitle(state, { documentType: "contract", plural: true });
    } else if (pathName === "inspection") {
      name = getTitle(state, { documentType: "inspection", plural: false });
    }

    return fromJSON({
      path: setPath,
      name,
    });
  });
};

export interface ICrumbRecord {
  path: string;
  name: string;
}

const initialState = {
  path: "",
  name: "",
};

export class CrumbRecord extends Record(initialState) implements ICrumbRecord {}
